// Lightweight User-Agent parsing done by hand instead of pulling in a
// library (ua-parser-js etc.) for a handful of regexes - good enough for
// "what browser/OS/device is visiting", not meant for anything security
// sensitive. Unlike the geo lookup, this is instant and 100% local (no
// network call), so it's fine to compute fresh on every page view instead
// of caching it per session.

const parseBrowser = (ua) => {
    if (/Edg\//.test(ua)) return { name: 'Edge', version: (ua.match(/Edg\/([\d.]+)/) || [])[1] || '' };
    if (/OPR\//.test(ua)) return { name: 'Opera', version: (ua.match(/OPR\/([\d.]+)/) || [])[1] || '' };
    if (/SamsungBrowser\//.test(ua)) return { name: 'Samsung Internet', version: (ua.match(/SamsungBrowser\/([\d.]+)/) || [])[1] || '' };
    if (/Firefox\//.test(ua)) return { name: 'Firefox', version: (ua.match(/Firefox\/([\d.]+)/) || [])[1] || '' };
    // Chrome/Safari on iOS report themselves via CriOS/FxiOS, not their
    // desktop tokens - check those before the generic Chrome/Safari match.
    if (/CriOS\//.test(ua)) return { name: 'Chrome', version: (ua.match(/CriOS\/([\d.]+)/) || [])[1] || '' };
    if (/FxiOS\//.test(ua)) return { name: 'Firefox', version: (ua.match(/FxiOS\/([\d.]+)/) || [])[1] || '' };
    if (/Chrome\//.test(ua)) return { name: 'Chrome', version: (ua.match(/Chrome\/([\d.]+)/) || [])[1] || '' };
    if (/Safari\//.test(ua) && /Version\//.test(ua)) return { name: 'Safari', version: (ua.match(/Version\/([\d.]+)/) || [])[1] || '' };
    return { name: 'Unknown', version: '' };
};

const parseOS = (ua) => {
    if (/Windows NT 10\.0/.test(ua)) return 'Windows 10/11';
    if (/Windows NT/.test(ua)) return 'Windows';
    if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
    if (/Mac OS X/.test(ua)) return 'macOS';
    if (/Android/.test(ua)) return 'Android';
    if (/Linux/.test(ua)) return 'Linux';
    return 'Unknown';
};

const parseDeviceType = (ua) => {
    if (/iPad/.test(ua) || (/Android/.test(ua) && !/Mobile/.test(ua))) return 'Tablet';
    if (/Mobi|iPhone|iPod/.test(ua) || (/Android/.test(ua) && /Mobile/.test(ua))) return 'Mobile';
    return 'Desktop';
};

export const getDeviceInfo = () => {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    const browser = parseBrowser(ua);
    return {
        browser: browser.name,
        browserVersion: browser.version,
        os: parseOS(ua),
        deviceType: parseDeviceType(ua),
        screenWidth: (typeof window !== 'undefined' && window.screen) ? window.screen.width : null,
        screenHeight: (typeof window !== 'undefined' && window.screen) ? window.screen.height : null,
        viewportWidth: typeof window !== 'undefined' ? window.innerWidth : null,
        viewportHeight: typeof window !== 'undefined' ? window.innerHeight : null,
    };
};
